import React, { useEffect } from 'react';
import { Toaster } from 'store/app/operation/showToastOperation';

const OPPlusWCToast = () => {
  useEffect(() => {
    const toaster = document.getElementById('op-toaster') as unknown as Toaster;

    const interval = setInterval(() => {
      const toast = customElements.get('wc-toast-notification');

      if (toast) {
        toaster.init({
          defaultTimeout: 2000,
        });
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return React.createElement(
    'wc-toast-notification',
    {
      id: 'op-toaster',
    },
    null,
  );
};

export default OPPlusWCToast;
